/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import PropTypes from 'prop-types'
import { Animation } from 'react-web-animation'
import { toTransform, toFlip, NO_ANIM } from '../actions/game'
import { LEVELS, log } from '../logs'
import { TransformPropType, AnimPropType } from '../prop-types'

import dotPattern from './backs/Seamless-Colorful-Sparse-Polka-Dot-Pattern.svg'

const Card = props => {
  log('Card', LEVELS.INFO, props)
  const {
    image,
    transform,
    animTransform = NO_ANIM,
    flipped,
    animFlipped = NO_ANIM,
    onClick,
    size
  } = props
  const cardStyle = { ...toTransform(transform) }
  if (size) {
    cardStyle.width = `${size}%`
  }
  const cardClasses = ['card']
  if (!size) {
    cardClasses.push('card-size')
  }
  if (animFlipped !== NO_ANIM || flipped) {
    cardClasses.push('hover')
  }
  const style = {
    backgroundImage: `url(${dotPattern})`
  }

  return (
    <Animation
      keyframes={animTransform.keyframes}
      timing={animTransform.timing}
      onFinish={animTransform.onFinish}
    >
      <div className={cardClasses.join(' ')} style={cardStyle}>
        <div
          className='flip-container'
          onClick={onClick}
        >
          <Animation
            keyframes={animFlipped.keyframes}
            timing={animFlipped.timing}
            onFinish={animFlipped.onFinish}
          >
            <div
              className='flipper'
              style={toFlip(flipped)}
            >
              <div className='front'>
                <img src={image} />
              </div>
              <div className='back'>
                <div style={style} />
              </div>
            </div>
          </Animation>
        </div>
      </div>
    </Animation>
  )
}

Card.propTypes = {
  image: PropTypes.string.isRequired,
  transform: TransformPropType,
  animTransform: AnimPropType,
  flipped: PropTypes.bool.isRequired,
  animFlipped: AnimPropType,
  onClick: PropTypes.func,
  size: PropTypes.number
}

Card.displayName = 'Card'

export default Card
